import { useEffect } from "react";
import { UtilsUseHistory } from "../utils/UtilsUseHistory";
import { useLoginOptionHooks } from "./login-option-hooks";
import { ApplicationState } from "../store";
import { LoginOptionState } from "../store/reducers/login-option-reducer";
import { useSelector } from "react-redux";
import { Cookie, LocalStorage } from "../services/storage";
import { COOKIE_GST_ATKN, EMAIL_LOGIN_VERIFICATION_RESULT, REDIRECT } from "../constants/storage";
import { LayoutState } from "../store/reducers/layout-reducer";
import { UtilsUser } from "../utils/UtilsUser";
import { ROUTES } from "../configs/routes";
import { UserState } from "../store/reducers/user-reducer";
import { useAuth } from "./auth-hooks";
import { useEmailSupport } from "../utils/email-supported/useEmailSupport";

export const useEmailLoginHooks = () => {
  const {
    toggleLoginModal,
    toggleEmailLoginModal,
    toggleEmailOtpModal,
    removeGstToken,
    removeRedirectSession,
  } = useLoginOptionHooks();
  const { logout } = useAuth();
  const { isEmailLoginSupported } = useEmailSupport();
  const { isLoginModalOpen, isEmailLoginModalOpen, isEmailOtpModalOpen } =
    useSelector<ApplicationState, LoginOptionState>(
      (state) => state.loginOption
    );
  const { selectedCountry } = useSelector<ApplicationState, LayoutState>(
    (state) => state.layout
  );
    const { userCountryCode } = useSelector<
      ApplicationState,
      UserState
    >((state) => state.user);
  const { go } = UtilsUseHistory();
  const isEmailLoginOngoing = isEmailLoginModalOpen || isEmailOtpModalOpen;
  const isLoginAttemptOngoing =
    isEmailLoginModalOpen || isEmailOtpModalOpen || isLoginModalOpen;

  // prevent login modal is open when user go back to page
  useEffect(() => {
    globalThis.onpopstate = () =>
      setTimeout(function () {
        if (isEmailLoginOngoing || isLoginModalOpen) {
          toggleEmailOtpModal(false);
          toggleLoginModal({ isLoginModalOpen: false });
          toggleEmailLoginModal(false);
          go(-1);
        }
      }, 0);
  }, [isEmailLoginOngoing, isLoginModalOpen]);

  // clear token and verification result when email login modal closed
  useEffect(
    () => {
      const emailLoginVerificationResult = LocalStorage.get(
        EMAIL_LOGIN_VERIFICATION_RESULT
      );
      const isVerifying =
        emailLoginVerificationResult &&
        emailLoginVerificationResult === "false";

      if (isVerifying && !isEmailLoginOngoing) {
        removeGstToken();
      }

      if (Cookie.get(COOKIE_GST_ATKN) === undefined) {
        localStorage.removeItem(EMAIL_LOGIN_VERIFICATION_RESULT);
      }
    },
     
    [isEmailLoginOngoing]
  );
  // if email login attempt is done, cleanup redirect session
  useEffect(() => {
    if (!isLoginAttemptOngoing) {
      removeRedirectSession();
    }
  }, [isLoginAttemptOngoing]);

  // Check if user is redirected back to home page after attempting
  // to directly access an authenticated route (deep link)
  useEffect(() => {
    if (!selectedCountry.code || !userCountryCode) return;
    // CHECK IF THE NEW selectedCountry doesn't support email login
    if (
      UtilsUser.isEmailLogin() &&
      isEmailLoginSupported(selectedCountry.code)
    ) {
      // remove email session
      logout();
      removeGstToken();
      sessionStorage.setItem(REDIRECT, ROUTES.MYDATA);
    }
  }, [userCountryCode, selectedCountry]);
};
